<template>
    <div class="group-progress-assignments-overview">
        <div class="group-progress-assignments-overview-options">
            <div class="assignments">
                <b-form-select
                    class="apprentice-primary-select group-progress-assignments-filter-select"
                    v-model="selectedAssignmentFilter"
                    :options="assignmentOptions"
                    @change="updateAssignmentFilter">
                </b-form-select>
            </div>

            <div class="sub-assignments">
                <b-form-select
                    class="apprentice-primary-select group-progress-subassignments-filter-select"
                    v-model="selectedSubAssignmentFilter"
                    :disabled="selectedAssignmentFilter === null"
                    :options="subAssignmentOptions">
                </b-form-select>
            </div>

            <div
                class="approve-all"
                v-if="selectedAssignmentFilter">
                <b-button
                    class="btn-checked btn-approve-all"
                    variant="primary"
                    @click="closeAll()">
                    alles goedkeuren
                </b-button>
            </div>
        </div>

        <design-2021-group-progress-assignments-overview-all-assignments-component
            v-if="selectedAssignmentFilter === null"
            :group-data-in="groupDataIn"
            :selected-status-in="selectedStatusIn"
            :assignments-options="assignmentOptions"
            :group-in="groupIn"
            :search-term-in="searchTermIn"
            :student-per-projects-in="studentPerProjectsIn">
        </design-2021-group-progress-assignments-overview-all-assignments-component>

        <design-2021-group-progress-assignments-overview-all-subassignments-component
            v-else-if="selectedAssignmentFilter !== null && selectedSubAssignmentFilter === null"
            :group-data-in="groupDataIn"
            :selected-status-in="selectedStatusIn"
            :sub-assignment-options="subAssignmentOptions"
            :group-in="groupIn"
            :search-term-in="searchTermIn"
            :student-per-projects-in="studentPerProjectsIn"
            :selected-assignment-filter="selectedAssignmentFilter"
            @updateGroupData="updateGroupData">
        </design-2021-group-progress-assignments-overview-all-subassignments-component>

        <design-2021-group-progress-assignments-overview-selected-subassignments-component
            v-else-if="selectedSubAssignmentFilter"
            :group-data-in="groupDataIn"
            :selected-status-in="selectedStatusIn"
            :sub-assignment-options="subAssignmentOptions"
            :group-in="groupIn"
            :search-term-in="searchTermIn"
            :student-per-projects-in="studentPerProjectsIn"
            :selected-sub-assignment-filter="selectedSubAssignmentFilter"
            @updateGroupData="updateGroupData">
        </design-2021-group-progress-assignments-overview-selected-subassignments-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-progress-assignments-overview-component',
    props: {
        groupDataIn: {
            type: Object,
            required: true,
        },
        groupIn: {
            type: Object,
            required: true,
        },
        selectedStatusIn: {
            type: Array,
            required: true,
        },
        searchTermIn: {
            type: String,
            required: false,
            default: '',
        },
        studentPerProjectsIn: {
            type: Array,
            required: false,
            default: [],
        },
    },

    data() {
        return {
            selectedAssignmentFilter: null,
            selectedSubAssignmentFilter: null,
        };
    },

    computed: {
        assignmentOptions() {
            let assignments = [{ value: null, text: this.$t('group.all_exercises') }];
            if (
                this.groupDataIn.sub_assignments.length > 0 &&
                this.groupDataIn.sub_assignments[0].assignments.length > 0
            ) {
                for (const subAssignment of this.groupDataIn.sub_assignments[0].assignments) {
                    const needle = this.groupDataIn.assignments.sub_assignments[0].assignments
                        .map((ass) => ass.id)
                        .indexOf(subAssignment.assignment_id);
                    const name =
                        needle !== -1 ? this.groupDataIn.assignments.sub_assignments[0].assignments[needle].name : '';
                    assignments.push({
                        value: subAssignment.assignment_id,
                        text: name,
                    });
                }
            }

            return assignments;
        },

        subAssignmentOptions() {
            let subAssignments = [{ value: null, text: this.$t('group.all_partial_exercises') }];
            if (!this.selectedAssignmentFilter) {
                return subAssignments;
            }

            for (const assignment of this.groupDataIn.sub_assignments[0].assignments) {
                if (assignment.assignment_id === this.selectedAssignmentFilter) {
                    for (const subAssignment of assignment.sub_assignments) {
                        subAssignments.push({
                            value: subAssignment.id,
                            text: subAssignment.name,
                        });
                    }
                }
            }
            return subAssignments;
        },
    },

    methods: {
        updateAssignmentFilter(selected) {
            if (selected === null || (selected !== null && this.selectedSubAssignmentFilter !== null)) {
                this.selectedSubAssignmentFilter = null;
            }
        },

        updateGroupData() {
            this.$emit('updateGroupData');
        },

        closeAll() {
            if (this.selectedSubAssignmentFilter) {
                this.alert
                    .confirm(
                        this.$t('group.approve_sub_assignment'),
                        this.$t('group.confirm_approve_sub_assignment'),
                        this.$t('group.approve'),
                    )
                    .then((confirm) => {
                        if (!confirm) {
                            return;
                        }

                        this.alert.saving();
                        let data = {
                            group_id: this.groupIn.id,
                            sub_assignment_id: this.selectedSubAssignmentFilter,
                        };

                        this.axios.post(this.routes.subAssignmentStatusCloseAll(), data).then(
                            (response) => {
                                this.updateGroupData();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    });
            } else {
                this.alert
                    .confirm(
                        this.$t('group.approve_assignment'),
                        this.$t('group.confirm_approve_assignment'),
                        this.$t('group.approve'),
                    )
                    .then((confirm) => {
                        if (!confirm) {
                            return;
                        }

                        this.alert.saving();
                        let data = {
                            group_id: this.groupIn.id,
                            assignment_id: this.selectedAssignmentFilter,
                        };

                        this.axios.post(this.routes.assignmentStatusCloseAll(), data).then(
                            (response) => {
                                this.updateGroupData();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
select {
    margin-bottom: 0;
}

.group-progress-assignments-overview {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

select,
.assignments,
.sub-assignments {
    width: 100%;
}

.group-progress-assignments-overview-options {
    display: flex;
    flex-direction: column;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.approve-all {
    align-self: center;
    flex: 1 0 auto;
    width: 100%;

    .btn-approve-all {
        width: 100%;

        &:before {
            display: none;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    select,
    .assignments,
    .sub-assignments {
        width: auto;
    }

    select {
        max-width: 300px;
    }

    .group-progress-assignments-overview-options {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-end;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .approve-all {
        width: auto;
        flex: 0 0 auto;

        .btn-approve-all {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .approve-all {
        .btn-approve-all {
            &:before {
                display: block;
            }
        }
    }
}
</style>
